import React, { useState } from 'react';
import styled from 'styled-components';
import {
  collabData,
  decorData,
  inspirationData,
  newData,
  outdoorData,
  swatchesData,
  windowData,
  furnitureData,
  wallpaperData,
  beddingData,
  fabricData,
  tradeData
} from '../../common/helper';
import MenuList from './MenuList';
import MenuListDetails from './MenuListDetails';

const Wrapper = styled.div``;

function MenuItemWrapper({ search }) {
  const [selected, setSelected] = useState(null);

  const resetSelected = () => {
    setSelected(null);
  };

  const getData = () => {
    switch (selected) {
      case 'new':
        return { name: 'New', details: newData };
      case 'furniture':
        return { name: 'Furniture', details: furnitureData };
      case 'decor':
        return { name: 'Decor', details: decorData };
      case 'outdoor':
        return { name: 'Outdoor', details: outdoorData };
      case 'wallpaper':
        return { name: 'Wallpaper', details: wallpaperData };
      case 'bedding':
        return { name: 'Bedding', details: beddingData };
      case 'window':
        return { name: 'Window', details: windowData };
      case 'fabric':
        return { name: 'Fabric', details: fabricData };
      case 'inspiration':
        return { name: 'Inspiration', details: inspirationData };
      case 'collaborations':
        return { name: 'Collaborations', details: collabData };
      case 'swatches':
        return { name: 'Swatches', details: swatchesData };
      case 'trade':
        return { name: 'Trade', details: tradeData };
      default:
        return null;
    }
  };

  const data = getData();

  return (
    <Wrapper>
      {data ? (
        <MenuListDetails
          className="mobile-menu"
          name={data.name}
          data={data.details}
          resetSelected={resetSelected}
        />
      ) : (
        <MenuList
          setSelected={setSelected}
          className="mobile-menu"
          search={search}
        />
      )}
    </Wrapper>
  );
}

export default MenuItemWrapper;
